import React from "react";

const getYoutubeEmbedUrl = (url) => {
  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.hostname.includes("youtu.be")) {
      return `https://www.youtube.com/embed/${parsedUrl.pathname.slice(1)}`;
    }

    const videoId = parsedUrl.searchParams.get("v");
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    }
  } catch (error) {
    return url;
  }

  return url;
};

function YoutubeComponentV2({ url, poster, autoPlay = true }) {
  const embedUrl = getYoutubeEmbedUrl(url);
  const src = `${embedUrl}${embedUrl.includes("?") ? "&" : "?"}rel=0&modestbranding=1${
    autoPlay ? "&autoplay=1&mute=1" : ""
  }`;

  return (
    <div
      className="!w-[94%] z-[2] bg-center bg-cover"
      style={{
        aspectRatio: "16 / 8.8",
        backgroundImage: poster ? `url(${poster})` : undefined,
      }}
    >
      <iframe
        title="Aprender Steam video"
        src={src}
        className="w-full h-full"
        style={{ border: 0 }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  );
}

export default YoutubeComponentV2;
